import script from "./Zoneamento.vue?vue&type=script&setup=true&lang=js"
export * from "./Zoneamento.vue?vue&type=script&setup=true&lang=js"

import "./Zoneamento.vue?vue&type=style&index=0&id=44e7fda3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44e7fda3"]])

export default __exports__